import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { Button, Group, Text, Tooltip } from '@mantine/core';
import { IDropZoneProps } from '../Types/BulkPricingTypes';
import { handleAddMatches, getFieldData } from '../utils';
import { IAppState } from '../../../../lib/types/AppState/index';

export const DropZone: React.FC<IDropZoneProps> = (props): ReactElement => {
  const masterAccountID = useSelector((state: IAppState) => state.session.organization.masterAccountId);
  const benchmarkYear = useSelector((state: IAppState) => state.session.benchmarkYear);
  const currency = useSelector((state: IAppState) => state.session.currency.code);
  const displayIn = useSelector((state: IAppState) => state.session.monetary_display);
  
  const { 
    checkedDataCuts, 
    job, 
    agingCode, 
    setMessages, 
    setHasDisplayedMessages,
    updateMatchesInState,
    setMatchDataLoading,
    setCheckedDataCuts,
  } = props;

  const cutIDs = checkedDataCuts.map((cut) => cut.id) as number[];
  const jobCurrency = getFieldData('currency_default', job.data, job.terms);
  const checkedDataCutCurrency = checkedDataCuts.length ? getFieldData('currency_default', checkedDataCuts[0].data, checkedDataCuts[0].terms) : null;
  const currenciesMatch = jobCurrency === checkedDataCutCurrency;

  const addSelectedOnClick = () => {
    handleAddMatches({
      setMessages,
      setHasDisplayedMessages,
      updateMatchesInState,
      cutIDs,
      benchmarkYear,
      agingCode,
      currency,
      masterAccountID,
      job,
      setMatchDataLoading,
      displayIn
    }).then(() => {
      setCheckedDataCuts([]);
    })
  }

  const color = (!cutIDs.length || !currenciesMatch) ? 'dark' : 'skyblue';

  return (
    <Group justify='center' mt='-5'>
      <Text fz='sm'>Drag and drop matches</Text>
      <Text fs='italic' fz='sm'>or</Text>
      <Tooltip label={!cutIDs.length ? 'No datacuts selected' : !currenciesMatch ? 'Selected data cut currency must match the org job currency' : 'Add selected'}>
        <Button 
          variant='transparent' 
          size='md' 
          color={color}
          disabled={!cutIDs.length || !currenciesMatch}
          onClick={addSelectedOnClick}
          style={{ textDecoration: 'underline', padding: 0, backgroundColor: 'transparent', fontSize: 'var(--mantine-font-size-sm)' }}
        >
          Add selected
        </Button>
      </Tooltip>
    </Group>
  )
};
